import React, { useState } from 'react'
import PartygroupsForm from './PartygroupsForm'
import { useParams } from 'react-router-dom';

const EditPartygroupPage = () => {
  const { id } = useParams();
  
  
  
  return (
    <>
    currentPartygroupId?(<PartygroupsForm formType='edit' currentPartygroupId={id} ></PartygroupsForm>):''
     
    </>
  )
}

export default EditPartygroupPage
